import React from 'react'
import './styles/index.scss'
import { ModalComponent } from 'components/CustomModal'
import { blockedCountryModalOption } from 'constants/modalOption'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { PrimaryButton } from 'components/Common/Button'
import { setIsUserBlock } from 'store/redux-slices/user'
import Icon from 'icons/Icon'

const BlockedCountryPageV1 = ({ showModal }) => {
  const { languageData, selectedLanguageCode } = useSelector((state) => state.language)
  const { countryBlockFromLogIn } = useSelector((state) => state.user)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  return (
    <ModalComponent
      showModal={showModal}
      handleClose={() => {
        navigate(`/${selectedLanguageCode?.toLowerCase()}`)
      }}
      {...blockedCountryModalOption}
    >
      <div className='text-center mb-3'>
        <Icon name='ban' className='icon-ban' />
      </div>
      <div className='page-content-403'>
        <p>{languageData?.countryBlocked}!</p>
        <p>
          {languageData?.notAcceptingVisitors}
          {languageData?.contactUsAt}
        </p>
        <p>
          {process.env.REACT_APP_SUPPORT_MAIL}
        </p>
      </div>
      {countryBlockFromLogIn &&
        <PrimaryButton className='mx-auto mt-4' onClick={() => dispatch(setIsUserBlock(false))}>
          Close
        </PrimaryButton>}
    </ModalComponent>
  )
}

export default BlockedCountryPageV1
